<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>

<p-dialog #dialog id="trade-selection-table-dialog"
          [header]="(dialogTitle|translate)"
          [showHeader]="true" [(visible)]="selectionTradeDialogVisible"
          [position]="'right'" [modal]="false" closable="true" [closeOnEscape]="true"
          [draggable]="true" [resizable]="false"
          [styleClass]="'selection-table-dialog'"
          [transitionOptions]="'150ms'"
          (visibleChange)="onVisibilityChange($event)"
>
  <ng-template pTemplate="content">
    <app-trade-selection-table #tradeSelectionTable class="app-trade-selection-table-button"
                               (selectedIdsChange)="selectionChange($event)"
                               (applySelectionChange)="applySelection($event)"
                               (doSingleAllocate)="singleAllocate($event)"
                               (doSplitAllocate)="splitAllocate($event)"
                               [tradeIds]="selectedTradeIds"
                               [filterWithValue]="filterWithValue"
                               [(tableLoading)]="tableLoading"
                               (tableLoadingChange)="tableLoadingChange.emit(tableLoading)"
                               [selectionTradeDialogVisible]="selectionTradeDialogVisible"
                               [selectionBase]="selectionBase"
                               [visibleColumns]="visibleColumns"
                               [viewConfig]="viewConfig"
                               [ctrlAMode]="ctrlAMode"
                               [selectionType]="selectionType"
                               [userView]="userView"
                               [tradeTableCurrentRequest]="tradeTableCurrentRequest"
    ></app-trade-selection-table>
  </ng-template>
  <ng-template pTemplate="footer">
      <span class="selection-table-left-footer">
        <span class="mr-5">{{ 'page.clearing.trade.selection.filters.ignore'|translate }}</span>
        <p-multiSelect [options]="filterWithValuesOptions"
                       [(ngModel)]="filterWithValue"
                       optionLabel="text" display="chip"
                       [optionValue]="'id'" appendTo="body"
                       filterBy="text"
                       [showHeader]="true"
                       (onChange)="filterChanged($event.value)"
                       [virtualScroll]="false" virtualScrollItemSize="10"
                       [disabled]="tableLoading" [optionDisabled]="tableLoading?'disabled':'none'"
        >
        </p-multiSelect>
        <button type="button" pRipple pButton class="clear-filter p-button-warning p-button p-button-icon-only"
                [icon]="'fas fa-xmark'" (click)="clearFilter()"
                [disabled]="tableLoading||!filterWithValue||filterWithValue.length==0"></button>
      </span>
    <span class="selection-table-right-footer">
      <button *ngIf="!isReadOnly" pButton type="button"
              [disabled]="tableLoading||!selectedTradeIds||selectedTradeIds.length==0||!splitAllocationEnabledValue"
              (click)="tradeSelectionTable.splitAllocate()"
              [pTooltip]="'page.clearing.trade.dialog.split-allocate'|translate" tooltipPosition="top"
              class="p-button-success p-button-sm icon mr-10" [icon]="'fas fa-users'"></button>
      <button *ngIf="!isReadOnly" pButton type="button"
              [disabled]="tableLoading||!selectedTradeIds||selectedTradeIds.length==0||!singleAllocationEnabledValue"
              (click)="tradeSelectionTable.singleAllocate()"
              [pTooltip]="'page.clearing.trade.dialog.single-allocate'|translate" tooltipPosition="top"
              class="p-button-success p-button-sm icon mr-10" [icon]="'fas fa-user'"></button>
      <button pButton type="button" [disabled]="tableLoading||!selectedTradeIds||selectedTradeIds.length==0"
              (click)="tradeSelectionTable.clearSelection()"
              [pTooltip]="'common.dialog.clear' | translate" [icon]="'pi pi-filter-slash'" tooltipPosition="top"
              class="p-button-danger p-button-sm icon mr-10"></button>
      <button pButton type="button" [disabled]="tableLoading||!selectedTradeIds||selectedTradeIds.length==0"
              (click)="close()"
              [pTooltip]="'common.dialog.close' | translate" tooltipPosition="top"
              class="p-button-warning p-button-sm icon mr-10" [icon]="'pi pi-times'"></button>
      <button pButton type="button"
              [disabled]="tableLoading||!selectedTradeIds||selectedTradeIds.length==0||!singleAllocationEnabledValue"
              (click)="tradeSelectionTable.applySelection()"
              [pTooltip]="'common.dialog.apply' | translate" [icon]="'fas fa-check'" tooltipPosition="top"
              class="p-button-help p-button-sm icon"></button>
      </span>
  </ng-template>
</p-dialog>
